import { Button } from "@/shared/components/ui/button";

interface FlightSelectionBarProps {
  selectedCount: number;
  onDelete: () => void;
  onHide: () => void;
  onPublish: () => void;
  onClear: () => void;
}

export function FlightSelectionBar({
  selectedCount,
  onDelete,
  onHide,
  onPublish,
  onClear,
}: FlightSelectionBarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-3 bg-white border-b">
      <Button variant={"default"} onClick={onDelete}>
        Удалить
      </Button>
      <Button variant={"default"} onClick={onHide}>
        Скрыть
      </Button>
      <Button variant={"default"} onClick={onPublish}>
        Опубликовать
      </Button>
      <Button variant={"secondary"} onClick={onClear}>
        Сбросить выбор
      </Button>
      <span className="text-sm text-[#1B3A6B] font-medium">
        Выбрано рейсов: {selectedCount}
      </span>
    </div>
  );
}
